<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <th>Neptun</th>
                    <th>Név</th>
                    <th>Email</th>
                    <th>Nem</th>
                    <th>Műveletek</th>
                </tr>
            </thead>
            <tr v-for="user in allowed_users" :key="user.id" class="hover">
                <td>{{ user.new_neptun }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ sex(user.sex) }}</td>
                <td>
                    <label for="modal" class="btn btn-info" @click="setModel(user)">
                        Szerkesztés
                    </label>
                </td>
            </tr>
        </table>

        <!-- Put this part before </body> tag -->
        <input type="checkbox" id="modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box grid gap-3">
                <div class="flex justify-between">
                    <h3 class="font-bold text-lg">Engedélyezet felhasználó szerkesztése</h3>
                    <label
                        for="modal"
                        @click="model = {}"
                        class="btn btn-sm btn-error btn-square cursor-pointer fill-base-content text-base-100 absolute right-2 top-2"
                    >
                        <CloseIcon transparent/>
                    </label>
                </div>
                <div class="grid gap-3">
                    <div class="form-control w-full">
                        <label>Neptun</label>
                        <input class="input outline" v-model="model.new_neptun" />
                    </div>
                    <div class="form-control w-full">
                        <label>Név</label>
                        <input class="input outline" v-model="model.name" />
                    </div>
                    <div class="form-control w-full">
                        <label>Email</label>
                        <input class="input outline" v-model="model.email" />
                    </div>
                    <div class="form-control w-full">
                        <label>Nem</label>
                        <select class="input outline" v-model="model.sex">
                            <option value="MALE">Férfi</option>
                            <option value="FEMALE">Nő</option>
                            <option value="OTHER">Egyéb</option>
                        </select>
                    </div>
                </div>
                <div class="modal-action">
                    <label
                        for="modal"
                        class="btn btn-outline w-full"
                        @click="
                            updateAllowedUser(model);
                            model = {};
                        "
                    >
                        Mentés
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CloseIcon from "../svg/CloseIcon";

export default {
    name: 'AllowedUsers',
    components: { CloseIcon },
    props: {
        period_id: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            model: {},
        };
    },
    computed: {
        ...mapGetters('Period', ['allowed_users']),
    },
    methods: {
        ...mapActions('Period', ['getAllowedUsersAsync', 'updateAllowedUser']),
        sex(val) {
            switch (val) {
                case 'MALE':
                    return 'Férfi';
                case 'FEMALE':
                    return 'Nő';
            }
            return 'Egyéb';
        },
        setModel(user) {
            this.model = { ...user };
        },
    },
    mounted() {
        this.getAllowedUsersAsync(this.period_id);
    },
};
</script>

<style scoped></style>
